import { render } from "./RuleView.vue?vue&type=template&id=154db912"
import script from "./RuleView.vue?vue&type=script&lang=js"
export * from "./RuleView.vue?vue&type=script&lang=js"

import "./RuleView.vue?vue&type=style&index=0&id=154db912&lang=scss"

import exportComponent from "/app/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@4.1.6__webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__